import { defineMobileFormWindow } from "@app/overlay";
import {
    StockPartialInventoryContentForm,
    type StockPartialInventoryContentFormProps,
} from "./components/StockPartialInventoryContentForm/StockPartialInventoryContentForm";

/** Окна карточки частичной инвентаризации склада. */
export const stockPartialInventoryCardWindows = {
    content: defineMobileFormWindow<StockPartialInventoryContentFormProps>({
        key: "stock.partialInventory.content",
        title: "Инвентаризация",
        component: StockPartialInventoryContentForm,
    }),
};
